import React, { useState } from 'react';
import { View } from 'react-native';

import RadioButton from './RadioButton';

export interface RadioButtonGroupProps {
  options: { labelText: string; secondaryText?: string; value: string }[];
  onPress: (value: string) => void;
  disabled?: boolean;
  isHovered?: boolean;
  isFocused?: boolean;
  isPressed?: boolean;
}

const RadioButtonGroup = ({
  options,
  onPress,
  disabled = false,
  isHovered = false,
  isFocused = false,
  isPressed = false,
}: RadioButtonGroupProps) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>();

  const handleSelect = (value: string) => {
    setSelectedValue(value);
    onPress(value);
  };

  return (
    <View>
      {options.map((item) => (
        <RadioButton
          key={`key-${item.value}`}
          labelText={item.labelText}
          secondaryText={item.secondaryText}
          checked={selectedValue === item.value}
          onPress={() => handleSelect(item.value)}
          disabled={disabled}
          id={`id-${item.value}`}
          isHovered={isHovered}
          isFocused={isFocused}
          isPressed={isPressed}
        />
      ))}
    </View>
  );
};

export default RadioButtonGroup;
